export function filterAssignableRoles (roles = []) {
  return roles.filter(role => role?.assignableInInterface !== false)
}

export function rolesArrayToMap (roles = []) {
  return roles.reduce((map, role) => {
    if (role?.id != null) {
      map[role.id] = role
    }
    return map
  }, {})
}
